module.exports = __webpack_public_path__ + "static/media/corporatesEmpty.284729d8.svg";